import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Uuid } from '../../../../../../../graphql';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../../../graphql.module';
import { JobInvitationFrag } from './fragments/JobInvitation.fragment.generated';
import { CreateJobInvitation } from './mutations/CreateJobInvitation.generated';
import { DeleteJobInvitation } from './mutations/DeleteJobInvitation.generated';
import { GetJobInvitations, GetJobInvitationsResult } from './queries/GetJobInvitations.generated';

export type JobInvitation = JobInvitationFrag;
export type TenantUser = GetJobInvitationsResult['usersInCurrentTenant'][number];

@Injectable({ providedIn: 'root' })
export class JobCrewInvitationsApiService {
    #apollo = inject(Apollo);
    get #gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    getInvitations(jobId: Uuid) {
        return this.#gql.query({
            query: GetJobInvitations,
            variables: { jobId },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    createInvitation(jobId: Uuid, contactId: Uuid) {
        return this.#gql.mutate({
            mutation: CreateJobInvitation,
            variables: { request: { jobId, contactId } },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    deleteInvitation(jobInvitationId: Uuid) {
        return this.#gql.mutate({
            mutation: DeleteJobInvitation,
            variables: { jobInvitationId },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
